
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import JobsCard from './jobscard/JobsCard';

import classes from './JobsList.module.scss';
import { Pagination } from '@mui/material';

const JobsList = ({
    jobs,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    onJobClick,
    activeJob,
    toast,
}) => {
    // console.log(count)
    const scrolledBottom = () => {
        // if (hasNextPage)
        // 	fetchNextPage();
    };
    const jobCardRef = useBottomScrollListener(scrolledBottom);
    return (
        <div ref={jobCardRef} className={`${classes['job-board-jobs-list']} d-flex flex-column gap-2`}>
            {jobs?.map((job) => (
                <div key={job.id} role="button" onClick={() => onJobClick(job.id)}>
                    <JobsCard
                        key={job.id}
                        jobData={job}
                        active={activeJob === job.id}
                        toast={toast}
                    />
                </div>
            ))}			
        </div>
    );
};

export default JobsList;
